namespace AgerLMS.Logging {
    export interface UserQuizAnswerRow {
        Id?: number;
        QuestionId?: number;
        CorrectAnswer?: QuestionChoices;
        UserAnswer?: QuestionChoices;
        Attempt?: number;
        IpNumber?: string;
        AuthToken?: string;
        QuestionQuizId?: number;
        Question?: string;
        QuestionChoiceA?: string;
        QuestionChoiceB?: string;
        QuestionChoiceC?: string;
        QuestionChoiceD?: string;
        QuestionChoiceE?: string;
        QuestionCorrectAnswer?: number;
        QuestionGrade?: number;
        InsertUserId?: number;
        InsertDate?: string;
        InsertUserDisplayName?: string;
    }

    export namespace UserQuizAnswerRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'Logging.UserQuizAnswer';
        export const deletePermission = '?';
        export const insertPermission = '?';
        export const readPermission = 'Logging:UserQuizAnswer:Read';
        export const updatePermission = '?';

        export declare const enum Fields {
            Id = "Id",
            QuestionId = "QuestionId",
            CorrectAnswer = "CorrectAnswer",
            UserAnswer = "UserAnswer",
            Attempt = "Attempt",
            IpNumber = "IpNumber",
            AuthToken = "AuthToken",
            QuestionQuizId = "QuestionQuizId",
            Question = "Question",
            QuestionChoiceA = "QuestionChoiceA",
            QuestionChoiceB = "QuestionChoiceB",
            QuestionChoiceC = "QuestionChoiceC",
            QuestionChoiceD = "QuestionChoiceD",
            QuestionChoiceE = "QuestionChoiceE",
            QuestionCorrectAnswer = "QuestionCorrectAnswer",
            QuestionGrade = "QuestionGrade",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
